import { Grid, Table, TableBody, TableContainer } from '@mui/material';
import { useState } from 'react';
import AppContainer from 'src/components/appComponents/AppContainer';
import Scrollbar from 'src/components/scrollbar';
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from 'src/components/table';
import { useGetLinkAllInstallReferrerQuery } from 'src/graphql';
import MarketingTableRow from 'src/sections/marketing/MarketingTableRow';
import MarketingTableToolbar from 'src/sections/marketing/MarketingTableToolbar';
import { IMarketingDto, IMarketingSearch } from 'src/types/marketing';
import { Marketing_TABLE_HEAD } from 'src/utils/tables-headers';

export default function MarketingPage() {
  const table = useTable();
  const [search, setSearch] = useState<IMarketingSearch>();

  const { data, isLoading } = useGetLinkAllInstallReferrerQuery({
    offset: table.offset,
    limit: table.rowsPerPage,
    ...(search?.keywords ? { keywords: { _ilike: `%${search.keywords}%` } } : {}),
    type: search?.type ? search.type : 'GOOGLE',
  });

  return (
    <AppContainer pageTitle="Marketing" routeLinks={[{ name: 'Marketing' }]}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MarketingTableToolbar
            // Search
            search={search}
            setSearch={setSearch}
          />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Scrollbar>
              <Table>
                <TableHeadCustom headLabel={Marketing_TABLE_HEAD} />
                <TableBody>
                  {isLoading
                    ? [...Array(table.rowsPerPage)].map((i, index) => (
                        <TableSkeleton key={index} sx={{ height: 80 }} />
                      ))
                    : data?.items?.map((row: IMarketingDto) => (
                        <MarketingTableRow key={row.id} row={row} />
                      ))}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          {data && (
            <TablePaginationCustom
              count={data?.total ?? 0}
              page={table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          )}
        </Grid>
      </Grid>
    </AppContainer>
  );
}
